import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/about',
          name: 'about',
          component: resolve => require(['@/view/About'], resolve),
          meta: {
            title: '关于胜源'
          },
        }, {
          path: '/organization',
          name: 'organization',
          component: resolve => require(['@/view/organization'], resolve),
          meta: {
            title: '分支机构'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '动态新闻'
          }
        },{
          path: '/detail',
          name: 'detail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: '新闻详情'
          }
        },{
          path: '/companyculture',
          name: 'companyculture',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '企业关怀'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '加入胜源'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js